import { useState, useEffect } from "react";
import { loadShifRosterListByDepartmentID } from "../services/shiftService";


const useShiftRoasterByDepartment = (editShiftAssignmentID, selectedDepartmentID) => {
    const [shiftRoaster, setShiftRoaster] = useState([]);
    const [selectedShiftRoaster, setSelectedShiftRoaster] = useState(null);
    const [selectedShiftRoasterID, setSelectedShiftRoasterID] = useState(null);
    const [isShiftRoasterDataLoaded, setIsShiftRoasterDataLoaded] = useState(false);

    // Fetch department data
    const fetchShiftRoaster = async (selectedID = null) => {       
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_department: selectedDepartmentID
        };

        try {
            const data = await loadShifRosterListByDepartmentID(para);
            if (data && data.length > 0) {
                setShiftRoaster(data);

                const initialShiftRoaster = data.find((dept) => dept.id === selectedID) || data[0];
                setSelectedShiftRoaster(initialShiftRoaster);
                setSelectedShiftRoasterID(initialShiftRoaster.id);
                setIsShiftRoasterDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    const fetchSelectedShiftRoaster = async (selectedID = null) => {
       
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_department: selectedID
        };

        try {
            const data = await loadShifRosterListByDepartmentID(para);
            if (data && data.length > 0) {
                setShiftRoaster(data);

                const initialShiftRoaster = data.find((dept) => dept.id === selectedID) || data[0];
                setSelectedShiftRoaster(initialShiftRoaster);
                setSelectedShiftRoasterID(initialShiftRoaster.id);
                setIsShiftRoasterDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftRoasterDataLoaded && editShiftAssignmentID === 0 ) {
            fetchShiftRoaster();
        }
    }, [isShiftRoasterDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadShiftRoasterByID = async (selectedID) => {
        await fetchShiftRoaster(selectedID);
    };

    const loadShiftRosterByDepartmentID = async (selectedID) => {     
        await fetchSelectedShiftRoaster(selectedID);
    };

   

    return {
        shiftRoaster,
        selectedShiftRoaster,
        selectedShiftRoasterID,
        setSelectedShiftRoaster,
        setSelectedShiftRoasterID,
        loadShiftRoasterByID,
        loadShiftRosterByDepartmentID,
    };
};

export default useShiftRoasterByDepartment;
